import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { GrDashboard, GrUser } from "../../../assets/icons/vander";
import { FaBars, BsGrid1X2 } from "../../../assets/icons/vander";
import { useSidebarStore } from "../../hooks";

// import {
//   GrDashboard,
//   PiBrowsers,
//   RiStethoscopeLine,
//   LuUser2,
//   PiWheelchairFill,
//   AiOutlineAppstore,
//   PiShoppingCart,
//   MdFlip,
//   FaRegFile,
//   BsEnvelopeOpen,
//   BiLogOutCircle,
//   TbFileInfo,
//   BsPostcard,
//   FaRegComment,
//   BsCalendar3,
//   SiPicardsurgeles,
//   TbStethoscope,
// } from "../../assets/icons/vander";

import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

export const Sidebar = ({ manuClass }) => {
  const {
    // Props
    toggle,

    // Methods
    invertToggle,
  } = useSidebarStore();

  const [manu, setManu] = useState("");
  const [subManu, setSubManu] = useState("");
  const location = useLocation();

  useEffect(() => {
    const current = location.pathname.substring(
      location.pathname.lastIndexOf("/") + 1
    );
    setManu(current);
    setSubManu(current);
  }, [location.pathname.substring(location.pathname.lastIndexOf("/") + 1)]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  // useEffect(() => {
  //   console.log(manu);
  // }, [manu]);

  // useEffect(() => {
  //   console.log(subManu);
  // }, [subManu]);

  return (
    <nav id="sidebar" className={manuClass}>
      <SimpleBar className="sidebar-content" data-simplebar>
        <div className={`sidebar-brand doctor ${toggle ? "toggle" : ""}`}>
          {/* <Link to="/doctor/main">
            <span className="sidebar-colored text-white fs-4 ">GOSAFE</span>
          </Link> */}
          <button onClick={() => invertToggle()} className="show-small">
            <FaBars className="icon" />
          </button>
          <div className="link-label">GOSAFE</div>
        </div>

        <ul className="sidebar-menu">
          <li className={`${manu === "main" || "" ? "active" : ""} doctor`}>
            <Link
              to="/doctor/main"
              className={`sidebar-link ${toggle ? "toggle" : ""}`}
            >
              <BsGrid1X2 className="flex-shrink-0 icon" />
              <div className="link-label">Dashboard</div>
            </Link>
          </li>
          {/* <li className={`${manu === "dash" || "" ? "active" : ""} doctor`}>
            <Link to="/doctor/main">
              <GrDashboard className="me-2 d-inline-block mb-0 icon" />
              inicio
            </Link>
          </li> */}

          {/* <li
            className={`sidebar-dropdown ms-0 ${
              ["doctors", "add-doctor", "doctors-item"].includes(manu)
                ? "active"
                : ""
            }`}
          >
            <Link
              to="#"
              onClick={(e) => {
                setSubManu(subManu === "doctors-item" ? "" : "doctors-item");
              }}
            >
              <TbStethoscope className="me-2 d-inline-block mb-0 icon" />
              Doctores
            </Link>
            <div
              className={`sidebar-submenu ${
                ["doctors", "add-doctor", "doctors-item"].includes(subManu)
                  ? "d-block"
                  : ""
              }`}
            >
              <ul>
                <li className={`${manu === "doctors" ? "active" : ""} ms-0`}>
                  <Link to="/secretary/doctors">Doctores</Link>
                </li>
                <li className={`${manu === "add-doctor" ? "active" : ""} ms-0`}>
                  <Link to="/secretary/add-doctor">Agregar doctor</Link>
                </li>
              </ul>
            </div>
          </li> */}

          {/* <li
            className={`sidebar-dropdown ms-0 ${
              ["patients", "add-patient", "patients-item"].includes(manu)
                ? "active"
                : ""
            }`}
          >
            <Link
              to="#"
              onClick={(e) => {
                setSubManu(subManu === "patients-item" ? "" : "patients-item");
              }}
            >
              <LuUser2 className="me-2 d-inline-block mb-0 icon" />
              Pacientes
            </Link>
            <div
              className={`sidebar-submenu ${
                ["patients", "add-patient", "patients-item"].includes(subManu)
                  ? "d-block"
                  : ""
              }`}
            >
              <ul>
                <li className={`${manu === "patients" ? "active" : ""} ms-0`}>
                  <Link to="/secretary/patients">Todos los pacientes</Link>
                </li>
                <li
                  className={`${manu === "add-patient" ? "active" : ""} ms-0`}
                >
                  <Link to="/secretary/add-patient">Agregar pacientes</Link>
                </li>
              </ul>
            </div>
          </li> */}

          {/* <li
            className={`${manu === "surgery-rooms" || "" ? "active" : ""} ms-0`}
          >
            <Link to="/secretary/surgery-rooms">
              <SiPicardsurgeles className="me-2 d-inline-block mb-0 icon" />
              Salas de procedimiento
            </Link>
          </li> */}

          {/* <li
            className={`sidebar-dropdown ms-0 ${
              [
                "procedure-calendar",
                "valuation-calendar",
                "calendars-item",
              ].includes(manu)
                ? "active"
                : ""
            }`}
          >
            <Link
              to="#"
              onClick={(e) => {
                setSubManu(
                  subManu === "calendars-item" ? "" : "calendars-item"
                );
              }}
            >
              <BsCalendar3 className="me-2 d-inline-block mb-0 icon" />
              Calendarios
            </Link>
            <div
              className={`sidebar-submenu ${
                [
                  "procedure-calendar",
                  "valuation-calendar",
                  "calendars-item",
                ].includes(subManu)
                  ? "d-block"
                  : ""
              }`}
            >
              <ul>
                <li
                  className={`${
                    manu === "procedure-calendar" ? "active" : ""
                  } ms-0`}
                >
                  <Link to="/secretary/procedure-calendar">Procedimiento</Link>
                </li>
                <li
                  className={`${
                    manu === "valuation-calendar" ? "active" : ""
                  } ms-0`}
                >
                  <Link to="/secretary/valuation-calendar">Valoración</Link>
                </li>
              </ul>
            </div>
          </li> */}

          {/* <li
            className={`sidebar-dropdown ms-0 ${
              [
                "register-shift",
                "register-shift-procedure",
                "summary-procedures",
                "registers-item",
              ].includes(manu)
                ? "active"
                : ""
            }`}
          >
            <Link
              to="#"
              onClick={(e) => {
                setSubManu(
                  subManu === "registers-item" ? "" : "registers-item"
                );
              }}
            >
              <BsCalendar3 className="me-2 d-inline-block mb-0 icon" />
              Registro de actividades
            </Link>
            <div
              className={`sidebar-submenu ${
                [
                  "register-shift",
                  "register-shift-procedure",
                  "summary-procedures",
                  "registers-item",
                ].includes(subManu)
                  ? "d-block"
                  : ""
              }`}
            >
              <ul>
                <li
                  className={`${
                    manu === "register-shift" ? "active" : ""
                  } ms-0`}
                >
                  <Link to="/secretary/register-shift">Registrar Jornada</Link>
                </li>
                <li
                  className={`${
                    manu === "register-shift-procedure" ? "active" : ""
                  } ms-0`}
                >
                  <Link to="/secretary/register-shift-procedure">
                    Registrar Procedimiento
                  </Link>
                </li>
                <li
                  className={`${
                    manu === "summary-procedures" ? "active" : ""
                  } ms-0`}
                >
                  <Link to="/secretary/summary-procedures">Resumen</Link>
                </li>
              </ul>
            </div>
          </li> */}
        </ul>
      </SimpleBar>
    </nav>
  );
};
